import { FC } from 'react'
import { MediaPicker } from 'types/mediaPicker'

type DownloadButtonProps = {
  mediaPicker: MediaPicker
  className?: string
}

const DownloadButton: FC<DownloadButtonProps> = ({
  mediaPicker,
  className,
}) => {
  return (
    <div
      className={className}
      onClick={() => {
        fetch('/api/cors?url=' + mediaPicker.url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/pdf',
          },
        })
          .then((response) => response.blob())
          .then((blob) => {
            // Create blob link to download
            const url = window.URL.createObjectURL(new Blob([blob]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
              'download',
              `download.${url.endsWith('png') ? 'png' : 'jpg'}`
            )

            // Append to html link element page
            document.body.appendChild(link)

            // Start download
            link.click()

            // Clean up and remove the link
            link.parentNode!.removeChild(link)
          })
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="41"
        height="41"
        viewBox="0 0 41 41"
      >
        <g
          id="Group_1398"
          data-name="Group 1398"
          transform="translate(-896 -233)"
        >
          <g
            id="Group_1388"
            data-name="Group 1388"
            transform="translate(895.855 232.855)"
            opacity="0.15"
            style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}
          >
            <circle
              id="Ellipse_63"
              data-name="Ellipse 63"
              cx="20.5"
              cy="20.5"
              r="20.5"
              transform="translate(0.145 0.145)"
              fill="#292729"
              style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}
            />
          </g>
          <g
            id="Group_1391"
            data-name="Group 1391"
            transform="translate(906 243)"
          >
            <line
              id="Line_199"
              data-name="Line 199"
              y1="13.782"
              transform="translate(10.196)"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              strokeWidth="1"
            />
            <path
              id="Path_377"
              data-name="Path 377"
              d="M34.32,35.97l-3.59,3.59-3.59-3.59"
              transform="translate(-20.533 -25.778)"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              strokeWidth="1"
            />
            <path
              id="Path_378"
              data-name="Path 378"
              d="M10.56,53.98V57H30.949V53.98"
              transform="translate(-10.56 -36.612)"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              strokeWidth="1"
            />
          </g>
        </g>
      </svg>
    </div>
  )
}

export default DownloadButton
